import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { CodeTable } from '../../../../core/model/v2/code-table';
import { Patient } from '../../../../core/models/patient/patient';
import {
  PatientChildren,
} from '../../../../core/models/patient/patientChildren';
import { CommonService } from '../../../../core/services/v2/common.service';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { UserService } from '../../../../core/services/v2/user.service';
import {
  WindowLoaderService,
} from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-children-guardian-edit',
  templateUrl: './patient-children-guardian-edit.component.html',
  styleUrls: ['./patient-children-guardian-edit.component.scss']
})
export class PatientChildrenGuardianEditComponent implements OnInit {
  @Input() childrenGuardian: PatientChildren;
  @Input() patientProfile: Patient;
  @Output() patientProfileChange = new EventEmitter<Patient>();
  @Output() toggleEvent = new EventEmitter();
  relationshipCodes: CodeTable;
  genderCodes: CodeTable;
  guardianshipLetterUrl: any;
  poaLetterUrl: any;
  userId: number;
  childrenGuardianForm = new FormData();
  errorMessage: string;
  calculateAge: number = 0;
  GuardianshipfileType: any;
  childrenGuardianfileType: any;
  constructor(
    private patientService: PatientService,
    private userService: UserService,
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private loaderService: WindowLoaderService) { }

  ngOnInit() {

    this.userService.getUserDetails().subscribe(
      (res) => {
        this.userId = res.id;
      },
      (error) => { console.error(error); });
    this.guardianshipLetterUrl = this.childrenGuardian.guardianshipLetter;
    this.poaLetterUrl = this.childrenGuardian.poaLetter;
    this.loadCodes();
    this.calculateAge = this.getAge(this.childrenGuardian.birthDate);
  }

  cancel() {
    this.toggleEvent.emit();
  }
  attachGuardianshipLetter(event) {
    this.loaderService.show();
    const file = event.target.files[0];
    this.GuardianshipfileType = file.type;
    this.childrenGuardianForm.append('GuardianshipLetterSource', file);
    const url = URL.createObjectURL(file);
    this.guardianshipLetterUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.childrenGuardian.guardianshipLetter = this.guardianshipLetterUrl;
    this.loaderService.hide();
  }

  changeDateOfBirth(e) {
    this.calculateAge = this.getAge(this.childrenGuardian.birthDate)
  }

  getAge(dob) {
    if (dob) {
      let age;
      const convertAge = new Date(dob);
      const timeDiff = Math.abs(Date.now() - convertAge.getTime());
      age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
      return age;
    }
    else{
      return 0;
    }
  }

  attachPoaLetter(event) {
    this.loaderService.show();
    const file = event.target.files[0];
    this.childrenGuardianfileType = file.type;
    this.childrenGuardianForm.append('POALetterSource', file);
    const url = URL.createObjectURL(file);
    this.poaLetterUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.childrenGuardian.poaLetter = this.poaLetterUrl;
    this.loaderService.hide();
  }

  loadCodes() {
    this.relationshipCodes = this.commonService.getItemCodesFiltered('CHILDRELATIONSHIP');
    this.genderCodes = this.commonService.getItemCodesFiltered('GENDER');
  }
  updateChildrenGuardian() {
    this.errorMessage = "";
    if (!this.childrenGuardian.name || !this.childrenGuardian.birthDate || !this.childrenGuardian.relationship)
      this.errorMessage = "Required fields should be filled";

    if (this.errorMessage.length > 0) return;

    this.loaderService.show();

    this.childrenGuardianForm.append('PatientId', this.patientProfile && this.patientProfile.id ? this.patientProfile.id.toString() : this.childrenGuardian.patientId.toString());
    if (this.childrenGuardian.id)
      this.childrenGuardianForm.append('Id', this.childrenGuardian.id.toString());

    if (this.childrenGuardian.name)
      this.childrenGuardianForm.append('Name', this.childrenGuardian.name);

    if (this.childrenGuardian.middleName)
      this.childrenGuardianForm.append('MiddleName', this.childrenGuardian.middleName);

    if (this.childrenGuardian.lastName)
      this.childrenGuardianForm.append('LastName', this.childrenGuardian.lastName);

    if (this.childrenGuardian.birthDate)
      this.childrenGuardianForm.append('BirthDate', this.datePipe.transform(this.childrenGuardian.birthDate, 'MM/dd/yyyy'));

    if (this.childrenGuardian.relationship)
      this.childrenGuardianForm.append('Relationship', this.childrenGuardian.relationship);

    if (this.childrenGuardian.gender)
      this.childrenGuardianForm.append('Gender', this.childrenGuardian.gender);

    this.childrenGuardianForm.append('Active', this.childrenGuardian.active ? 'true' : 'false');

    this.patientService.updatePatientChildrenDetails(this.childrenGuardianForm).subscribe(
      (res) => {
        if (res.isSuccess) {
          this.patientService.getCurrentPatientDetails().subscribe(
            (details) => {
              if (details) {
                this.patientProfile.patientChildren = details.patientChildren;
                this.patientProfileChange.emit(this.patientProfile);

              }
              this.toggleEvent.emit();
            },
            (error) => { console.error(error); },
            () => {
              this.loaderService.hide();
            }
          );
        } else
          console.error(res);
      },
      (error) => { console.error(error); },
      () => {
        this.loaderService.hide();
      }
    );
  }
}

